/* eslint-disable better-mutation/no-mutation */

import { localStore } from 'utils/storage';

class ResultSet {
    constructor(result) {
        this._result = result;
        this._result.orderByTimestamp = this.orderByTimestamp.bind(this);
        this._result.orderByValue = this.orderByValue.bind(this);
        this._result.orderByExpire = this.orderByExpire.bind(this);
    }

    get() {
        return this._result;
    }

    _orderBy(orderProp) {
        function orderByProp(a, b) {
            if (a[orderProp] === b[orderProp]) {
                return 0;
            }

            return a[orderProp] < b[orderProp] ? 1 : -1;
        }

        return this._result.sort(orderByProp);
    }

    orderByTimestamp() {
        return this._orderBy('timestamp');
    }

    orderByValue() {
        return this._orderBy('value');
    }

    orderByExpire() {
        return this._orderBy('expires');
    }
}

class StorageService {
    constructor(namespace, options = {}) {
        this.namespace = namespace || 'default';
        this.datastore = options.datastore || localStore;
    }

    getDataSafe() {
        return this.datastore.getItem(this.namespace) || {};
    }

    store(data) {
        this.datastore.setItem(this.namespace, data);
        return true;
    }

    remove(key) {
        let data = this.getDataSafe(),
            encodedKey = encodeURI(key).toLowerCase();

        this.purge(encodedKey, data);
    }

    purge(key, data) {
        delete data[key];
        this.store(data);
        return true;
    }

    get(key) {
        let data = this.getDataSafe(),
            encodedKey = encodeURI(key).toLowerCase();

        if (
            data[encodedKey] &&
            data[encodedKey].expires &&
            data[encodedKey].expires < new Date().getTime()
        ) {
            this.purge(encodedKey, data);
        }

        return (data[encodedKey] && data[encodedKey].value) || null;
    }

    set(key, value, expires, timestamp) {
        let data = this.getDataSafe(),
            encodedKey = encodeURI(key).toLowerCase();

        data[encodedKey] = {
            expires: (expires && expires.getTime()) || null,
            timestamp:
                (timestamp && timestamp.getTime()) || new Date().getTime(),
            value: value
        };

        this.datastore.setItem(this.namespace, data);

        return data[encodedKey] || null;
    }

    removeExpired() {
        let data = this.getDataSafe(),
            prop;

        for (prop in data) {
            if (data.hasOwnProperty(prop)) {
                if (
                    data[prop].expires &&
                    data[prop].expires < new Date().getTime()
                ) {
                    this.purge(prop, data);
                }
            }
        }
    }

    fetch() {
        function addRow(row, prop, propValue) {
            row.key = decodeURI(prop);
            row.value = propValue.value;
            row.timestamp = propValue.timestamp;
            return row;
        }

        let data = this.getDataSafe(),
            rows = [],
            prop;

        for (prop in data) {
            if (data.hasOwnProperty(prop)) {
                rows.push(addRow({}, prop, data[prop]));
            }
        }

        return new ResultSet(rows).get();
    }

    flush() {
        return this.datastore.clearByPrefix(this.namespace);
    }
}

export default StorageService;
